import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=ddeb5968&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddeb5968')) {
      api.createRecord('ddeb5968', component.options)
    } else {
      api.reload('ddeb5968', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=ddeb5968&", function () {
      api.rerender('ddeb5968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/views/my/_id.vue"
export default component.exports